import React from 'react'
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
 
import ExDetails from './ExDetails';
import { Link } from "react-router-dom";
import bannerleft from "../../images/hero-art.jpg";
import TrendingCollections from './Trendingcollections'; 
import Createnftprocess from './Createnftprocess';
import Trendingcollectors from './Trendingcollectors';
import Latestnew from '../Latestnews/Latestnew';
import Categoriespage from './Categoriespage/Categoriespage';
import Trendingtableft from './Trendingtabhomepage/Trendingtableft';
import Tokentable from './Tokentable.js/Tokentable';

const Home = () => {
    return (
        <>
            <Box className='banner'>
                <Container maxWidth='xl'>
                    <Grid container spacing={2}>
                        <Grid item lg={6} sm={12} md={6} xs={12}>
                            <img src={bannerleft} width='100%' />
                        </Grid>
                        <Grid item lg={6} sm={12} md={6} xs={12} alignSelf={'center'}>
                            <Box className='unique' padding={5}>
                                <Typography variant='h2'>
                                    Discover, Collect & <br></br> Sell <span className='sell_pt' style={{ background: 'linear-gradient(to right, #D01498,#647ECB),' }}> Extraordinary </span>  <br></br> NFTs
                                </Typography>
                                <Typography variant='h6'>
                                    The Crypto Monkey is a high-quality collection of 100 unique monkeys on the NFTMart marketplace.
                                </Typography>
                                <Box className='maketrade'>
                                    <Link to='/create'>
                                        <Button variant='outlined' className="trade">Create Nft</Button>
                                    </Link>
                                    <Link to='/Notarize'>
                                        <Button variant='outlined' className="trade">Notarize</Button>
                                    </Link>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container> 
            </Box> 
            <Trendingtableft /> 
            <TrendingCollections />
            <Tokentable />
            <ExDetails />
            <Trendingcollectors />
            <Createnftprocess />
            <Categoriespage />
            <Latestnew /> 
 

        </>

    )
}

export default Home;